import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {
  LotteriesDialogContentComponent,
  LotteryDialogListItemDirective
} from "../lotteries-dialog-content/lotteries-dialog-content.component";
import {
  OpenLotteryListItemComponent
} from "../../../../pages/apartments-tab/components/open-lottery-list-item/open-lottery-list-item.component";
import {NotificationPage} from "../../multi-page-notification/multi-page-notification.component";
import {NewEligibleLotteriesNotificationDto} from "homey-housing-lottery-app-dto";
import {UserService} from "../../../user.service";

@Component({
  selector: 'homey-new-eligible-lotteries-dialog-content',
  imports: [
    LotteriesDialogContentComponent,
    LotteryDialogListItemDirective,
    OpenLotteryListItemComponent,
  ],
  templateUrl: './new-eligible-lotteries-dialog-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewEligibleLotteriesDialogContentComponent extends NotificationPage<NewEligibleLotteriesNotificationDto> {
  private readonly userService = inject(UserService);
  protected readonly autoApplying = computed(
    () => {
      const user = this.userService.user();

      return user?.status === 'active' && user.autoApplySettings.enabled;
    }
  )

}
